// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"AtExternalLink_linkContainer__3JxDR"};